<!--if this component is hide then the dashboard/pagination.component.scss most be modify-->
<div class="container" *ngIf="false">
  <div class="container-in">
    <b>bc&#64;dev:</b>
    <input type="text">
  </div>
</div>
